// src/components/Employees/EmployeesPage.js
import React, { useState } from 'react';
import POSEmployeeManagement from '../employees/POSEmployeeManagement';
import EmployeeAttendance from '../employees/EmployeeAttendance';

const EmployeesPage = ({
  employees,
  onAddEmployee,
  onUpdateEmployee,
  onDeleteEmployee
}) => {
  const [view, setView] = useState('management');

  return (
    <div className="space-y-6 mt-6">

      {/* Tabs */}
      <div className="flex justify-center space-x-4 mb-6">
        <button
          onClick={() => setView('management')}
          className={`${
            view === 'management'
              ? 'bg-[#58735A] text-[#F9EFD7]'
              : 'bg-gray-300 text-gray-700'
          } py-2 px-4 rounded-md transition duration-200`}
        >
          Gestión de Empleados
        </button>

        <button
          onClick={() => setView('attendance')}
          className={`${
            view === 'attendance'
              ? 'bg-[#58735A] text-[#F9EFD7]'
              : 'bg-gray-300 text-gray-700'
          } py-2 px-4 rounded-md transition duration-200`}
        >
          Asistencia
        </button>
      </div>

      {/* Render controlado */}
      {view === 'management' ? (
        <POSEmployeeManagement
          key="management"
          employees={employees}
          onAddEmployee={onAddEmployee}
          onUpdateEmployee={onUpdateEmployee}
          onDeleteEmployee={onDeleteEmployee}
        />
      ) : (
        <EmployeeAttendance
          key="attendance"
          employees={employees}
        />
      )}

    </div>
  );
};

export default EmployeesPage;